import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';
import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';
import EnhancedSearchDropdown from '../EnhancedSearchDropdown';

const useStyles = makeStyles({
  group: {
    fontWeight: 'bold',
    color: '#000000',
  },
  item: {
    textIndent: '12px',
  },
  menuItem: {
    opacity: '1 !important',
  },
});

const SearchSelect = ({
  entityName,
  savedSearches,
  selectedSearch,
  onChange,
  label = 'Show',
  labelCustomStyles = {},
  dropdownCustomStyles = {},
  groupByEntityName,
  enableSearchNameSearch,
}) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const [groupedSavedSearches, setGroupedSavedSearches] = useState();
  const selectOptions = groupedSavedSearches || savedSearches;
  const selectedValue =
    selectOptions.length && selectOptions.find((option) => option.searchName === selectedSearch)
      ? selectedSearch
      : '';

  const { isMobileDevice } = useWindowDimensions();

  useEffect(() => {
    if (groupByEntityName) {
      const sortedSearches = _.sortBy(savedSearches, (s) => s.translatedEntityName);
      const groupedSearches = _.groupBy(sortedSearches, (s) => s.entityName);
      const groupedOptions = Object.keys(groupedSearches).reduce((options, entityName) => {
        const { translatedEntityName } = sortedSearches.find(
          (search) => search.entityName === entityName
        );

        options.push({
          id: entityName,
          translatedSearchName: translatedEntityName || '-',
          group: true,
        });
        return options.concat(groupedSearches[entityName]);
      }, []);

      setGroupedSavedSearches(groupedOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedSearches]);

  const renderSelectOption = (search) => {
    if (!groupByEntityName) {
      return search.translatedSearchName;
    }
    return (
      <span className={search.group ? classes.group : classes.item}>
        {search.translatedSearchName}
      </span>
    );
  };

  return (
    <Grid
      style={{ display: isMobileDevice ? 'block' : 'flex' }}
      container
      alignItems="center"
      spacing={1}
      ui-ta="RecordsContainerDropDown"
    >
      {!isMobileDevice && (
        <Grid item>
          <div
            style={{
              fontSize: 14,
              lineHeight: '70px',
              height: 55,
              marginBottom: 8,
              ...labelCustomStyles,
            }}
          >
            {translateString(label)}
          </div>
        </Grid>
      )}
      <Grid item>
        {enableSearchNameSearch ? (
          <EnhancedSearchDropdown
            storeKey={entityName}
            selectOptions={selectOptions}
            onChange={onChange}
            selectedValue={selectedValue}
            showRecent
          />
        ) : (
          <Select
            style={{ minWidth: 253, marginTop: isMobileDevice ? 0 : 16, ...dropdownCustomStyles }}
            value={selectedValue}
            onChange={({ target }) => onChange(target.value)}
            canDeselect={false}
            fullWidth={isMobileDevice}
          >
            {selectOptions.map((search) => (
              <MenuItem
                className={classes.menuItem}
                key={search.id}
                value={search.searchName}
                disabled={search.group}
              >
                {renderSelectOption(search)}
              </MenuItem>
            ))}
          </Select>
        )}
      </Grid>
    </Grid>
  );
};

export default SearchSelect;
